import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Public route component that redirects to dashboard if user is already authenticated
 */
const PublicRoute = () => {
  const { isLogged } = useAuth();

  // Show loading state while checking auth status
  if (isLogged === null) {
    return <div>Loading...</div>; // Or a proper loading spinner
  }

  // If user is logged in, redirect to dashboard or the redirect URL
  if (isLogged) {
    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params.get('redirect');
    return <Navigate to={redirectUrl || "/dashboard"} replace />;
  }

  // Otherwise, render the public route
  return <Outlet />;
};

export default PublicRoute;
